export default "__VITE_ASSET__DvI7Qu1h__"